module.exports = __webpack_public_path__ + "img/sun-dust.72d47a6e.svg";